export function fmtRating(value: number): string {
  return Number.isFinite(value) ? value.toFixed(3) : '—'
}

export function signed(value: number): string {
  if (!Number.isFinite(value)) return '—'
  const prefix = value >= 0 ? '+' : ''
  return `${prefix}${value.toFixed(3)}`
}

export function formatDateTime(value: string): string {
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return value
  return date.toLocaleString(undefined, {
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  })
}
